// Combined Menu functionality
(function() {
    'use strict';

    // Track if menu is already initialized
    let isMenuInitialized = false;
    
    // Store the original width to detect actual resizes
    let lastWindowWidth = window.innerWidth;
    
    // Main function to handle all menu functionality
    function initializeMenu() {
        // Don't reinitialize on page navigation if width is the same
        if (isMenuInitialized && window.innerWidth === lastWindowWidth) {
            return;
        }
        
        // Update width tracker
        lastWindowWidth = window.innerWidth;
        
        // First, handle the dropdowns for submenu items
        setupDropdownMenus();
        
        // Then, handle the responsive behavior (More menu)
        setupResponsiveDropdown();
        
        // Mark as initialized
        isMenuInitialized = true;
    }
    
    function setupDropdownMenus() {
        const navItems = document.querySelectorAll('.gh-head-menu li');
        const mainMenuItems = [];
        const subMenus = {};

        // Build menu structure
        navItems.forEach((item, index) => {
            const link = item.querySelector('a');
            if (!link) return; // Skip items without a link

            const linkText = link.textContent.trim();
            if (linkText.startsWith('-')) {
                const parentIndex = mainMenuItems.length - 1;
                if (!subMenus[parentIndex]) {
                    subMenus[parentIndex] = [];
                }
                subMenus[parentIndex].push(item);
            } else {
                mainMenuItems.push(item);
            }
        });

        // Apply dropdowns
        mainMenuItems.forEach((item, index) => {
            const subMenuItems = subMenus[index];
            if (subMenuItems) {
                // Check if the dropdown and caret icon already exist
                if (!item.querySelector('.dropdown') && !item.querySelector('.caret-down')) {
                    const dropdown = document.createElement('ul');
                    dropdown.className = 'dropdown';
                    
                    subMenuItems.forEach(child => {
                        const link = child.querySelector('a');
                        if (link) {
                            // Remove the leading dash and trim whitespace
                            const cleanedText = link.textContent.replace(/^\s*-\s*/, '').trim();
                            
                            // Update the HTML content of the link
                            link.innerHTML = cleanedText;
                        }
                        dropdown.appendChild(child);
                    });
                    
                    item.classList.add('has-dropdown');
                    
                    // Add caret-down icon
                    const caretIcon = document.createRange().createContextualFragment(`
                        <svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" fill="currentColor" viewBox="0 0 256 256" class="icon caret-down">
                            <rect width="256" height="256" fill="none"></rect><polyline points="208 96 128 176 48 96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></polyline>
                        </svg>
                    `);
                    item.querySelector('a').appendChild(caretIcon);
                    
                    item.appendChild(dropdown);
                    
                    // Add hover event listeners
                    item.addEventListener('mouseenter', () => {
                        item.classList.add('show-dropdown');
                        item.querySelector('.caret-down').classList.add('rotate');
                    });
                    
                    item.addEventListener('mouseleave', () => {
                        item.classList.remove('show-dropdown');
                        item.querySelector('.caret-down').classList.remove('rotate');
                    });
                }
            }
        });
    }
    
    function setupResponsiveDropdown() {
        const mediaQuery = window.matchMedia('(max-width: 767px)');
        const menu = document.querySelector('.gh-head-menu');
        const nav = menu?.querySelector('.nav-new');
        if (!nav) return;
        
        // Get a fresh state of the nav
        if (!window.originalNavHTML) {
            // Save the original structure once
            window.originalNavHTML = nav.innerHTML.trim();
        } else {
            // Reset to original state for calculation
            nav.innerHTML = window.originalNavHTML;
        }
        
        // Handle mobile-specific styling
        if (mediaQuery.matches) {
            // Get only direct child li elements first, then their dropdown children
            const topLevelItems = nav.querySelectorAll(':scope > li');
            let allItems = [];
            
            topLevelItems.forEach(function(item) {
                allItems.push(item);
                // Add dropdown items if they exist
                const dropdownItems = item.querySelectorAll('.dropdown > li');
                dropdownItems.forEach(function(dropdownItem) {
                    allItems.push(dropdownItem);
                });
            });
            
            allItems.forEach(function (item, index) {
                item.style.transitionDelay = `${0.02 * (index + 1)}s`;
            });
            return;
        }
        
        // For desktop, create the responsive "More" dropdown if needed
        const submenuItems = [];
        
        // Store the current width for later comparison
        while ((nav.offsetWidth + 64) > menu.offsetWidth) {
            if (nav.lastElementChild) {
                submenuItems.unshift(nav.lastElementChild);
                nav.lastElementChild.remove();
            } else {
                break;
            }
        }
        
        if (!submenuItems.length) {
            document.body.classList.add('is-dropdown-loaded');
            return;
        }
        
        const toggle = document.createElement('button');
        toggle.setAttribute('class', 'nav-more-toggle gh-icon-btn');
        toggle.setAttribute('aria-label', 'More');
        toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';
        
        const wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'gh-dropdown');
        
        if (submenuItems.length >= 10) {
            document.body.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = `repeat(${Math.ceil(submenuItems.length / 2)}, 1fr)`;
        } else {
            document.body.classList.remove('is-dropdown-mega');
        }
        
        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });
        
        toggle.appendChild(wrapper);
        nav.appendChild(toggle);
        
        document.body.classList.add('is-dropdown-loaded');
        
        // Set up toggle for the "More" dropdown
        toggle.addEventListener('click', function(e) {
            document.body.classList.toggle('is-dropdown-open');
            e.stopPropagation();
        });
        
        document.addEventListener('click', function(e) {
            if (!toggle.contains(e.target)) {
                document.body.classList.remove('is-dropdown-open');
            }
        });
    }
    
    // Initialize once on page load
    initializeMenu();
    
    // Re-initialize on DOM ready as fallback
    document.addEventListener('DOMContentLoaded', initializeMenu);
    
    // Handle window resize properly
    let resizeTimer;
    window.addEventListener('resize', function() {
        // Mark as not initialized to force recalculation
        isMenuInitialized = false;
        // Use debouncing to avoid excessive calculations
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initializeMenu, 100);
    });
    
    // Set up for link navigation - prevent flicker
    document.addEventListener('click', function(e) {
        if (e.target.tagName === 'A' && !e.target.classList.contains('nav-more-toggle')) {
            // Don't reset menu initialization state during navigation
            isMenuInitialized = true;
        }
    });
})(); 